import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kad',
  templateUrl: './kad.component.html',
  styleUrls: ['./kad.component.scss']
})
export class KadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
